import { Typography, Box } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useCommentCount } from './hooks/useCommentCount'

interface CommentCount {
  count: number
  isDevice: boolean
}

export const CommentCount = ({ count, isDevice }) => {
  const theme = useTheme()
  const { renderCommentText } = useCommentCount(count)

  return (
    <Typography component="span" variant={isDevice ? 'caption' : 'body2'}>
      <Box display="flex" color={theme.colors.accent1} fontWeight="bold">
        {renderCommentText()}
      </Box>
    </Typography>
  )
}
